interface Tag {
    id: string;
    name: string;
}

export interface TaggedClinician {
    tags?: { items: Tag[] } | null;
    clinicianTeams?: { tags?: { items: Tag[] } | null }[] | null;
}

/**
 * A clinician's tags, their own followed by their teams', each tag appearing once.
 *
 * A tag applied to two of a clinician's teams, or to both the clinician and a team,
 * describes them once.
 */
export const clinicianTagsForDisplay = (clinician: TaggedClinician): Tag[] => {
    const teamTags = (clinician.clinicianTeams ?? []).flatMap((team) => team.tags?.items ?? []);
    const seen = new Set<string>();
    return [...(clinician.tags?.items ?? []), ...teamTags].filter((tag) => {
        if (seen.has(tag.id)) {
            return false;
        }
        seen.add(tag.id);
        return true;
    });
};
